// extracted by mini-css-extract-plugin
export default {"mainContainer":"MainLayout_mainContainer__d9Tcb","sidebar":"MainLayout_sidebar__YwZa6","main":"MainLayout_main__zx70k"};